module.exports = __webpack_public_path__ + "05f894714d70b7727235492c11b18f52.ttf";